import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-end-call',
  imports: [MatButtonModule, TranslateModule],
  template: `
    <div class="custom-context-menu-wrapper no-subscript d-flex flex-column gap-3 p-2 mb-2">
      <button mat-flat-button color="primary" (click)="confirm.emit()">
        {{ 'VideoCall.CallControls.EndCall' | translate }}
      </button>
    </div>
  `,
})
export class EndCallComponent {
  @Output() confirm = new EventEmitter<string | null>();
}
